import { Settings } from "react-slick";
import {
  error_toast_icon_IMG,
  success_toast_check_IMG,
  warning_toast_icon_IMG,
} from "./Images";
import {
  getAppleAppStoreAppLink,
  getBaseURL,
  getDefaultLatitude,
  getDefaultLongtude,
  getGoogleMapsAPIKey,
  getGooglePlayStoreAppLink,
  getImageBaseUrl,
} from "./ProductionBuildFunctions";

// ============================================================
// BASE API URLs
// ============================================================
export const BASE_URL = getBaseURL(window.appConfig?.Environment); //?===> Localhost => TEST
export const IMAGE_BASE_URL = getImageBaseUrl(window.appConfig?.Environment);
// export const BASE_URL = "http://10.10.100.5:8898"; //?===> Localhost 2 => DEV
// export const BASE_URL = "https://api.domecare-pharma.com"; //?===> GoDaddy
// export const BASE_URL = "https://apps.domecare-pharma.com"; //?===> DomeCare APPs
export const Current_API_Version = "v3";
export const BASE_APIS_URL = BASE_URL + `/${Current_API_Version}/api`;
// export const BASE_APIS_URL = BASE_URL + `/api`;
export const BASE_Images_API_URL = IMAGE_BASE_URL;
export const EXCEL_BASE_API_URL = BASE_URL;
export const SOCKET_BASE_URL = BASE_URL;
export const BASE_LOCAL_IMAGES_DIR = "/assets/images/";
// ============================================================
// API Keys and Constants
// ============================================================
export const googleMapsApiKey = getGoogleMapsAPIKey(
  window.appConfig?.Environment,
);
export type APIMethod = "GET" | "POST" | "PATCH" | "PUT" | "DELETE";
export const Methods: Record<APIMethod, APIMethod> = {
  GET: "GET",
  POST: "POST",
  PATCH: "PATCH",
  PUT: "PUT",
  DELETE: "DELETE",
};
export type Method = (typeof Methods)[keyof typeof Methods];
// ============================================================
// Default Values
// ============================================================
// export const SyrianTimeZone = "+03:00";
// export const SyrianTimeZone = getTimezoneOffset();

export const DefaultProductExcelImage = "DefaultProduct.png";
export const DefaultDrugExcelImage = "icons/DrugDefault.png";
export const DefaultProductsExcelExample = "ProductSample.xlsx";
export const DefaultDrugsExcelExample = "DrugsSample.xlsx";
export const DefaultNofiticationsSound = "notification_sound.mp3";
export const DefaultGooglePlayLinkForMobileApp = getGooglePlayStoreAppLink(
  window.appConfig?.Environment,
);
export const DefaultAppStoreLinkForMobileApp = getAppleAppStoreAppLink(
  window.appConfig?.Environment,
);
export const DefaultLatitude = getDefaultLatitude(
  window.appConfig?.Environment,
);
export const DefaultLongtude = getDefaultLongtude(
  window.appConfig?.Environment,
);
export const DefaultNavigateDelay = window.appConfig?.NAVIGATE_DELAY || 500; //?ms
export const DefaultRequestTimeOut = 600000; //? ms ===> 10 minutes
export const DefaultRequestDetailsCanceledOrderCode = 165;
export const DefaultPhoneNumberMinDigitsLength = 9;
export const DefaultPhoneNumberMaxDigitsLength = 10;
export const DefaultTelephoneMinDigitsLength = 4;
export const DefaultTelephoneMaxDigitsLength = 15;
export const DefaultInfiniteScrollThreshold = "200px";
export const DefaultResponseCodeForContinueRegistration = 131;
export const DefaultResponseCodeForContinueStaffRegisteration = 59;
export const DefaultPharmacyOffersSearchLocalStorageKey = "offerSearchTerm";
export const DefaultScreenSizeToRedirectToAppsStore = 800;
export const DefaultQueryStaleTime = 10000; //? ms;
// ============================================================
// Currency & Labels
// ============================================================
export const GlobalSyrianCurrentLabelEn = "SYP";
export const GlobalSyrianCurrentLabelAr = "ل.س";

// ============================================================
// Languages
// ============================================================
export const ArabicCode = "ar";
export const EnglishCode = "en";
export const LanguagesENUM = {
  ar: ArabicCode,
  en: EnglishCode,
};

// ============================================================
// UI & UX Constants
// ============================================================
export const CardCounterSpeed = 125;
export const GlobalToasterDuration =
  window.appConfig?.GLOBAL_TOASTER_DURATION || 5000;
export const AuthToastDuration = 5000;
export const notificationsAudioFilePath = `${BASE_LOCAL_IMAGES_DIR}/${DefaultNofiticationsSound}`;
export const LoaderFirstColor = "#ffffff";
export const LoaderSecondColor = "#007BFF";
export const ToasterSuccessImageUrl = `${BASE_LOCAL_IMAGES_DIR}/${success_toast_check_IMG}`;
export const ToasterErrorImageUrl = `${BASE_LOCAL_IMAGES_DIR}/${error_toast_icon_IMG}`;
export const ToasterWarningImageUrl = `${BASE_LOCAL_IMAGES_DIR}/${warning_toast_icon_IMG}`;
export const maxDateOffer = "2042-12-31";
export const MAX_CART_QUANTITY = 9999;
export const MAX_ITEMS_EACH_CART_QUANTITY = 50;
export const MAX_CARTS_COUNT = 50;
// ============================================================
// Regular Expressions
// ============================================================
export const urlRegex =
  /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(\/\S*)?$/;
export const phoneRegExp = /^[0-9]{10}$/;
export const NumericValuesOnlyRegex = /^d*$/;
export const timeRegExp = /^([01]\d|2[0-3]):([0-5]\d)$/;

// ============================================================
// Timers
// ============================================================
export const LongStaleTime = 30000000; // ms
export const RequestDetailsFirstTimer =
  window.appConfig?.REQUEST_DETAILS_FIRST_TIMER || 300000; // ms => 5 minutes
export const RequestDetailsSecondTimer =
  window.appConfig?.REQUEST_DETAILS_SECOND_TIMER || 60000; // ms => 1 minute
export const TimeOverRequestReviewPageFirstTimer =
  window.appConfig?.TIME_OVER_REQUEST_REVIEW_PAGE_FIRST_TIMER || 20000; // ms => 20 Seconds
export const TimeOverRequestReviewPageSecondTimer =
  window.appConfig?.TIME_OVER_REQUEST_REVIEW_PAGE_SECOND_TIMER || 60000; // ms => 1 minute
export const SocketReconnectDuration =
  window.appConfig?.SOCKET_RECONNECT_DURATION || 2000; // ms
export const OrderCounterTimeOutDurationValue = 1000; //count down every : 1000 ms => 1s
export const DefaultSearchBounceInterval = 1000; // ms => 1s
// ============================================================
// Pagination & Table Constants
// ============================================================
export const TablePaginationCount = 10;
export const GeneralTableRowsPerPage = [5, 10, 20, 30, 40, 50];
export const PharmacyOrderDetailsItemsTableItemPerPage = 1000;
export const MaximumProductGalleryImages = 3;
export const ProductGalleryMaxFiles = 3;
export const DefaultFromDaysSpaceInNewOrderDatePopup = 7;
// ============================================================
// Enum Definitions
// ============================================================

export const OfferStepsEnum = {
  initial: "initial",
  chooseQuantity: "chooseQuantity",
  offerDetails: "offerDetails",
};

export const OrderTypesEnum = {
  ALL: "All",
  SPECIFIC: "Specific",
  RETURNED: "Return",
  SHARED: "Shared",
};

export const OrderSocketEventTypes = {
  LOCKORDER: "LockOrder",
  UNLOCKORDER: "UnLockOrder",
  PREVIEWORDER: "PreviewOrder",
};

export const OrderStatusEnum = {
  PENDING: "Pending",
  CANCELED: "Canceled",
  ACCEPTED: "Accepted",
  REJECTED: "Rejected",
  EXPIRED: "Expired",
  ACCEPTEDPARTIALLY: "AcceptedPartially",
  RETURNED: "Returned",
};

export const NotificationsTypes = {
  NEW_ORDER: "NewOrder",
  NEW_ORDER_FOR_ALL: "NewOrderForAll",
  OFFER_EXPIRED: "OfferExpired",
  WAREHOUSE_OFFERS: "WarehouseOffers",
  NEW_OFFER: "NewOffer",
  ACCEPTED_ORDER: "AcceptedOrder",
  NEW_PATIENT_ORDER: "NewPatientOrder",
  REJECTED_ORDER: "RejectedOrder",
  REJECTED_FACILITY: "RejectedFacility",
  ACCEPTED_FACILITY: "AcceptedFacility",
  SHARED_CART: "SharedCart",
  EARN_POINTS:"EarnPoints"
};

export const OfferTypesEnum = {
  Quantity: "Quantity",
  Discount: "Discount",
  PackageQuantity: "PackageQuantity",
  PackageDiscount: "PackageDiscount",
  PackageNormal: "PackageNormal",
};

export const ProductStatusEnum = {
  available: "Available",
  unavailable: "Unavailable",
  hide: "Hide",
};

export const DrugStatusEnum = {
  available: "Available",
  unavailable: "Unavailable",
  hide: "Hide",
};

export const ProfileTabsEnum = {
  facilityInfo: "facility_info",
  facilityAddress: "facility_address",
  contactInfo: "contact_info",
  workingTimes: "working_times",
  companies: "companies",
  InsuranceCompanies: "insurance_companies",
};

export const FileMimeTypesEnum = {
  PDF: "application/pdf",
  PNG: "image/png",
  JPEG: "image/jpeg",
  JPG: "image/jpg",
};

export const DEFAULTOFFERSFILTERPACKAGESTYPES = {
  Package: [
    OfferTypesEnum.PackageNormal,
    OfferTypesEnum.PackageQuantity,
    OfferTypesEnum.PackageDiscount,
  ],
};

export const DEFAULTEGUARDEDEXCLUDEDROUTES = [
  "profile",
  "settings",
  "notifications",
];

// ============================================================
// File Upload Constants
// ============================================================
export const SUPPORTED_FORMATS = [
  "application/pdf",
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/jfif",
];

export const allowedImagesExtensions = [
  "image/jpeg",
  "image/jpg",
  "image/jfif",
  "image/png",
];

export const allowedProductImagesExtensions =
  "image/png, image/jfif, image/jpeg, image/jpg";

export const allowedFilesExtensions = [
  "application/pdf",
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/jfif",
];

export const allowedExcelFilesExtensions = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel.sheet.macroEnabled.12",
  "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
];
export const DefaultOrderExcelFileName = "OrderExcel.xlsx";
export const DefaultOrderExcelFileExtension =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

// ============================================================
// MIME Type to Extension Mapping
// ============================================================
export const LicenseMimeTypeToExtensionMap: { [key: string]: string } = {
  "application/pdf": "PDF",
  "image/jpeg": "JPEG",
  "image/png": "PNG",
  "application/vnd.ms-excel": "XLS",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "XLSX",
  "application/vnd.ms-excel.sheet.macroEnabled.12": "XLSM",
  "application/vnd.ms-excel.sheet.binary.macroEnabled.12": "XLSB",
};

// ============================================================
// Search & Table Settings
// ============================================================
export const tableImportExcelButtonOptions = [
  {
    id: 0,
    title: "excel_addition",
    desc: "excel_addition_desc",
  },
  {
    id: 1,
    title: "excel_delte_and_replace",
    desc: "excel_delte_and_replace_desc",
  },
];

// ============================================================
// Slider Settings (React Slick)
// ============================================================
export const MostWantedSliderSettings: Settings = {
  className: "center",
  centerMode: false,
  infinite: true,
  centerPadding: "60px",
  slidesToShow: 1,
  speed: 500,
  rows: 2,
  slidesPerRow: 1,
  arrows: false,
  dots: true,
  customPaging: (index) => (
    <div
      className={`mx-1 h-2.5 w-2.5 rounded-full bg-gray-400 ${
        index === 0 ? "h-3 w-3 bg-red-500" : ""
      }`}
    />
  ),
  appendDots: (dots: any) => (
    <div>
      <ul className="m-0 flex justify-center">{dots}</ul>
    </div>
  ),
};

// ============================================================
// Order Table Toggle Data :

export const ToggleTableData = [
  {
    id: 1,
    tableName: "patient_orders",
  },
  {
    id: 2,
    tableName: "my_orders",
  },
];
// ============================================================
// ============================================================
// Help Center
// ============================================================
export const HelpCenterVideoUrl =
  "https://youtu.be/XfqOB4hvxlY?si=QkoVYY4ih-of1kHc";
